import { BaseVisitor } from './Parser/Visitor';
export var FErrorType;
(function (FErrorType) {
    FErrorType["UNDEFINED_FIELD"] = "UNDEFINED_FIELD";
    FErrorType["UKNOWN_FUNCTION"] = "UNKNOWN_FUNCTION";
})(FErrorType || (FErrorType = {}));
export class FormulaErrorBase {
    constructor(line, column) {
        this._line = line;
        this._column = column;
    }
    get line() {
        return this._line;
    }
    get column() {
        return this._column;
    }
}
export class UndefinedFieldError extends FormulaErrorBase {
    constructor(line, column, fieldName) {
        super(line, column);
        this._fieldName = fieldName;
    }
    get type() {
        return FErrorType.UNDEFINED_FIELD;
    }
    get fieldName() {
        return this._fieldName;
    }
    get message() {
        return `Reference to undefined field ${this.fieldName}`;
    }
}
export class UnknownFunctionError extends FormulaErrorBase {
    constructor(line, column, functionName) {
        super(line, column);
        this._functionName = functionName;
    }
    get type() {
        return FErrorType.UKNOWN_FUNCTION;
    }
    get functionName() {
        return this._functionName;
    }
    get message() {
        return `Unknown function ${this.functionName} called`;
    }
}
export class Validator extends BaseVisitor {
    constructor(fieldResolver, funcResolver) {
        super();
        this._fieldResolver = fieldResolver;
        this._funcResolver = funcResolver;
        this._errors = new Array();
    }
    get fieldResolver() {
        return this._fieldResolver;
    }
    get funcResolver() {
        return this._funcResolver;
    }
    get errors() {
        return this._errors;
    }
    /**
     * Visitors
     */
    visitFieldLiteralNode(node) {
        const startLoc = node.location.start;
        const field = this.fieldResolver.getField(startLoc.offset);
        if (field != null) {
            switch (field.type) {
                case 'MODELCALC':
                    if (this.funcResolver.getCalcFunc(field) == null) {
                        this.errors.push(new UndefinedFieldError(startLoc.line, startLoc.column, node.value));
                    }
                    break;
            }
        }
        else {
            this.errors.push(new UndefinedFieldError(startLoc.line, startLoc.column, node.value));
        }
    }
    visitCallExpressionNode(node) {
        const startLoc = node.location.start;
        if (this.funcResolver.getFunc(startLoc.offset) == null) {
            this.errors.push(new UnknownFunctionError(startLoc.line, startLoc.column, node.callee));
        }
    }
}
